import type { BaseOptionType } from 'antd/es/select';

// Идентификаторы
export const SPECIALIST_ID = 'specialist';
export const ADMIN_ID = 'admin';
export const ACCOUNTANT_ID = 'accountant';
export const MANAGER_ID = 'manager';
export const OWNER_ID = 'owner';

// Лейблы
export const SPECIALIST_LABEL = 'Специалист';
export const ADMIN_LABEL = 'Администратор';
export const ACCOUNTANT_LABEL = 'Бухгалтер';
export const MANAGER_LABEL = 'Менеджер';
export const OWNER_LABEL = 'Владелец';

// Все вместе
export const ROLES: BaseOptionType[] = [
  {
    label: SPECIALIST_LABEL,
    value: SPECIALIST_ID,
  },
  {
    label: ADMIN_LABEL,
    value: ADMIN_ID,
  },
  {
    label: ACCOUNTANT_LABEL,
    value: ACCOUNTANT_ID,
  },
  {
    label: MANAGER_LABEL,
    value: MANAGER_ID,
  },
  {
    label: OWNER_LABEL,
    value: OWNER_ID,
  },
];
